export default "__VITE_ASSET__S43_6e6g__"